<template>
  <div class="courseWrap">
    <md-content class="md-scrollbar md-layout">
      <div
        v-for="item in courseList"
        cols="auto"
        :key="item._id"
        class="md-layout-item md-xlarge-size-25 md-large-size-25 md-medium-size-25 md-small-size-25 md-xsmall-size-100 courseItem"
      >
        <v-card elevation="2">
          <v-img
            :lazy-src="item.sourse_image"
            class="coureListImg"
            height="140px"
            :src="item.sourse_image"
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
              </v-row>
            </template>
          </v-img>
          <div class="con">
            <p class="courseName">{{ item.name }}</p>
            <p class="studyTime">已有{{item.collectNum?item.collectNum<=0?0:item.collectNum :0}}人收藏</p>
            <div class="tostudy">
              <p>进入学习</p>
            </div>
          </div>
        </v-card>
      </div>
    </md-content>
  </div>
</template>

<script>
import { getstudyCourse } from '@/api/userData.js';
export default {
  // name:'learningCourses',收藏夹
  data() {
    return {
      variants: ['one', 'two', 'tree', 'four'],
      courseList: [

      ],
    };
  },
  mounted(){
    this.getstudyCourse()
  },
  methods:{
        getstudyCourse(){
      let userData = null;
      if(window.localStorage.getItem('USER_INFO')){
         userData = JSON.parse(window.localStorage.getItem('USER_INFO'))
      }
      let params = {
           userId:userData.user._id||''
      }
      getstudyCourse(params).then(res=>{
        if(res.data){
        // console.log(res.data,'======================')
        this.courseList = res.data;
        }

      })
    },
  }
};
</script>

<style scoped>
.courseWrap {
  width: 100%;
  height: auto;
  /* padding: 10px; */
  overflow: hidden;
  /* border: 1px solid gray; */
}

.courseItem {
  margin: 10px 0;
}
.con {
  width: 100%;
  height: auto;
  padding: 10px 0;
}
.courseName {
  font-size: 16px;
  margin-bottom: 10px;
  color: #000;
  padding: 0 10px;
}

.studyTime {
  font-size: 15px;
  color: #5b5b5b;
  margin-bottom: 10px;
  padding: 0 10px;
}
.tostudy {
  width: 100%;
  height: auto;
  padding: 10px 0;
  text-align: center;
  border-top: 1px solid #a7a7a7;
}

.tostudy p {
  font-size: 14px;
  margin-bottom: 0px;
  line-height: 30px;
  height: 30px;
}
</style>
